import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { MantineProvider } from '@mantine/core';
import { Provider } from 'jotai';
import { Toaster } from './components/common/Toaster';
import { CameraProvider } from './contexts/CameraContext';

// Fetch base path from environment variables (e.g., REACT_APP_BASE_PATH)
const basePath = process.env.REACT_APP_BASE_PATH ?? '/';
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <MantineProvider>
    <BrowserRouter basename={basePath}>
      <Provider>
        <CameraProvider>
          <App />
          <Toaster />
        </CameraProvider>
      </Provider>
    </BrowserRouter>
  </MantineProvider>
);
